import { StarIcon } from "@phosphor-icons/react";
import { useIntl } from "react-intl";

type Props = {
  stars: number;
};

export function HotelStars({ stars }: Props) {
  const intl = useIntl();

  if (!stars) return null;

  return (
    <div className="flex items-center gap-2">
      <div className="flex" aria-hidden>
        {Array.from(Array(Number(stars))).map((_, index) => (
          <StarIcon
            key={index}
            size={12}
            color="var(--color-amber-500)"
            weight="fill"
          />
        ))}
      </div>
      <span className="text-sm text-text-primary">
        {intl.formatMessage({ id: "hotels.card.stars" }, { stars })}
      </span>
    </div>
  );
}
